import { render, staticRenderFns } from "./trackCreat2.vue?vue&type=template&id=037a86c4"
import script from "./trackCreat2.vue?vue&type=script&lang=js"
export * from "./trackCreat2.vue?vue&type=script&lang=js"
import style0 from "./trackCreat2.vue?vue&type=style&index=0&id=037a86c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports